import layout from '@/components/common/layout';
import collegeList from '../views/college/list';
import collegeCreate from "../views/college/create";

export default [
    {
        path: '/college',
        component: layout,
        children: [
            {
                path: 'list',
                meta: {
                    metaInfo: {
                        title: "学院列表",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'college_list',// 子选项
                    }
                },
                component: collegeList,
            },
            {
                path: 'create',
                meta: {
                    metaInfo: {
                        title: "新增学院",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'college_list',// 子选项
                    }
                },
                component: collegeCreate,
            },
            {
                path: 'edit',
                meta: {
                    metaInfo: {
                        title: "编辑学院",
                        keywords: "",
                        description: ""
                    },
                    requireLogin: true,
                    menu: {
                        parent: '380',// 父选项
                        child: 'college_list',// 子选项
                    }
                },
                component: collegeCreate,
            },
        ]
    },
];
